import { render } from "./pricingpage.vue?vue&type=template&id=4cfea512&scoped=true"
import script from "./pricingpage.vue?vue&type=script&lang=js"
export * from "./pricingpage.vue?vue&type=script&lang=js"

import "./pricingpage.vue?vue&type=style&index=0&id=4cfea512&scoped=true&lang=css"

import exportComponent from "C:\\xampp\\htdocs\\bmac\\ims-web-api\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4cfea512"]])

export default __exports__